/* assets/rivyo-cleanup.js */
(function () {
  function tidy(root) {
    // 1) Прибираємо середню оцінку типу "5.0"
    root.querySelectorAll(
      '.rivyoRatingValue, .rivyoAvg, .rivyo-average, [itemprop="ratingValue"]'
    ).forEach(el => el.remove());

    // 2) Залишаємо лише число відгуків (без "Відгуки/Reviews")
    // Обходимо вузли з текстом і чистимо патерни "24 Відгуків", "(24 Reviews)" тощо
    root.querySelectorAll('.rivyoReviewWidget, [class*="review"], [class*="reviews"]').forEach(el => {
      [...el.childNodes].forEach(node => {
        if (node.nodeType !== 3) return; // текстовий вузол
        let t = node.textContent;
        // перетворюємо "24 Відгуків"/"24 Reviews" -> "24"
        t = t.replace(/\(?\s*(\d+)\s*(відгук(и|ів)?|reviews?)\s*\)?/ig, '$1');
        // прибираємо окреме слово "Відгуки/Reviews", якщо без числа
        t = t.replace(/\b(відгук(и|ів)?|reviews?)\b/ig, '').trim();
        node.textContent = t ? ' ' + t : '';
      });
    });
  }

  function run() {
    document.querySelectorAll('.rivyoReviewWidget').forEach(tidy);
  }

  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();